(function( factory ) {
	if ( typeof define === "function" && define.amd ) {
		define( ["jquery", "../jquery.validate"], factory );
	} else if (typeof module === "object" && module.exports) {
		module.exports = factory( require( "jquery" ) );
	} else {
		factory( jQuery );
	}
}(function( $ ) {

/*
 * Translated default messages for the jQuery validation plugin.
 * Locale: RU (Russian; русский язык)
 */
$.extend( $.validator.messages, {
	required: "Это поле необходимо заполнить.",
	remote: "Пожалуйста, введите правильное значение.",
	email: "Пожалуйста, введите корректный адрес электронной почты.",
	url: "Пожалуйста, введите корректный URL.",
	date: "Пожалуйста, введите корректную дату.",
	dateISO: "Пожалуйста, введите корректную дату в формате ISO.",
	number: "Пожалуйста, введите число.",
	digits: "Пожалуйста, вводите только цифры.",
	creditcard: "Пожалуйста, введите правильный номер кредитной карты.",
	equalTo: "Пожалуйста, введите такое же значение ещё раз.",
	extension: "Пожалуйста, выберите файл с правильным расширением.",
	maxlength: $.validator.format( "Пожалуйста, введите не больше {0} символов." ),
	minlength: $.validator.format( "Пожалуйста, введите не меньше {0} символов." ),
	rangelength: $.validator.format( "Пожалуйста, введите значение длиной от {0} до {1} символов." ),
	range: $.validator.format( "Пожалуйста, введите число от {0} до {1}." ),
	max: $.validator.format( "Пожалуйста, введите число, меньшее или равное {0}." ),
	min: $.validator.format( "Пожалуйста, введите число, большее или равное {0}." )
} );
return $;
}));
(function (factory) {
	if (typeof define === "function" && define.amd) {
		define(["jquery", "../jquery.validate"], factory);
	} else if (typeof module === "object" && module.exports) {
		module.exports = factory(require("jquery"));
	} else {
		factory(jQuery);
	}
}(function ($) {
	$.extend($.validator.messages, {
		dateISO: 'Пожалуйста, введите корректную дату.',
		time: 'Пожалуйста, введите корректное время.',

		datemin: $.validator.format('Пожалуйста, введите дату, большую или равную {0}.'),
		datemax: $.validator.format('Пожалуйста, введите дату, меньшую или равную {0}.'),
		daterange: $.validator.format('Пожалуйста, введите дату от {0} до {1}.'),
		timemin: $.validator.format('Пожалуйста, введите время, большее или равное {0}.'),
		timemax: $.validator.format('Пожалуйста, введите время, меньшее или равное {0}.'),
		timerange: $.validator.format('Пожалуйста, введите время от {0} до {1}.'),
		mask: 'Введите корректное значение, соответствующее маске ввода.',
		phone: 'Пожалуйста, введите корректный номер.',
		pacemail: 'Пожалуйста, введите корректный адрес электронной почты.',
		touristname: 'Разрешены только заглавные латинские буквы, тире и пробел.',
	});
	return $;
}));
